import {
	PartialTenantCustomizations,
} from "src/tenantCustomizations/TenantCustomizations";
import { LehtoPurchaseRequestDataGridActionBarComponents } from "src/tenantCustomizations/tenants/lehto/LehtoPurchaseRequestDataGridActionBarComponents";
import { LehtoDocumentsOfObjectDataGridContextMenuComponents } from "src/tenantCustomizations/tenants/lehto/LehtoDocumentsOfObjectDataGridContextMenuComponents.tsx";

export const lehtoCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
		},
	},
	purchaseRequestsDataGridActionBarComponents: LehtoPurchaseRequestDataGridActionBarComponents,
	documentsOfObjectDataGridContextMenuComponents:
		LehtoDocumentsOfObjectDataGridContextMenuComponents,
} as const;
